<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;">招生运营</span>
      / 运营培训
    </div>
    <div class="content">
      <div class="main">
        <el-form size="mini" ref="form" :model="course_form" label-position="left" class="form" @submit.native.prevent>
          <el-form-item label="课程类型">
            <el-radio-group @change="tchGetTchCurriculum" v-model="course_form.training_type_id">
              <el-radio label>全部</el-radio>
              <el-radio v-for="item of subjectList" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="所属科目">
            <el-radio-group @change="tchGetTchCurriculum1" v-model="course_form.subjectId">
              <el-radio label>全部</el-radio>
              <el-radio label="public">公开</el-radio>
              <el-radio v-for="item of subjectList1" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item class="input_left">
            <el-input v-model="course_form.title" placeholder="请输入课程名称" @keyup.enter.native="search"></el-input>

            <el-button type="primary" style="margin-left: 20px" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-row :gutter="20">
          <el-col :span="6" v-for="item of curriculumList" :key="item.id">
            <div class="video_list">
              <div @click="handleClickCard(item)" class="courses_img" :style="{
                  backgroundImage: 'url(' + item.img_url + ')',
                }"></div>
              <div class="courses_title">
                <div style="overflow: hidden">
                  <div class="title_subject">
                    <div class="title_name" :title="item.title">{{ item.title }}</div>
                  </div>
                  <div class="top_tag">{{ item.runTrainingTypeName }}</div>
                </div>
                <div class="title_bottom">
                  <div class="left_bottom" :title="`共 ${ item.video_num } 节 | ${ item.host }`">
                    共 {{ item.video_num }} 节 | {{ item.host }}
                  </div>
                  <div class="right_bottom">{{ item.tch_num }}人已参加</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div style="margin: 20px; text-align: right">
          <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { trainingList } from "@/api/teachingResearchTraining.js";
// import { tchGetTchSubjectAuth } from "@/api/classroom/teacher_api";
import { trainingList, listType } from '@/api/operationalActivitiesPc.js'
import { getZoneSchoolSubjectList } from '@/api/community.js'

export default {
  data() {
    return {
      firstTime: true,
      page_size: 20,
      page_no: 1,
      total: 0,
      course_form: {
        subjectIds: [],
        training_type_id: '',
        title: '',
        subjectId: '',
      },
      curriculumList: [],
      subjectList: [],
      subjectList1: [], //所属科目
    }
  },
  activated() {
    if (this.firstTime === false) {
      this.listType()
    }
  },
  mounted() {
    if (this.firstTime === true) {
      // this.trainingList();
      this.listType()
    }
    this.tchGetTchSubjectAuth()
    // this.getinfo();
  },
  methods: {
    tchGetTchCurriculum(val) {
      this.course_form.training_type_id = val
      this.trainingList()
    },
    tchGetTchCurriculum1(val) {
      this.course_form.subjectId = val
      this.trainingList()
    },

    //搜索
    search() {
      this.page_no = 1
      this.trainingList()
    },
    //列表
    listType() {
      console.log('查询老师科目权限')
      listType().then((res) => {
        this.subjectList = res.runTrainingTypeList
        this.trainingList()
      })
    },
    tchGetTchSubjectAuth() {
      console.log('查询老师科目权限')
      getZoneSchoolSubjectList().then((res) => {
        this.subjectList1 = res.subjectList
        console.log('获取老师权限列表')
        console.log(res)

        if (res.subjectList.length == 0) {
          this.$message.warning('无科目权限')
          return
        }
      })
    },

    //获取列表

    trainingList() {
      trainingList({
        subjectId: this.course_form.subjectId,
        training_type_id: this.course_form.training_type_id,
        // subjectIds: JSON.stringify(this.course_form.subjectIds),
        title: this.course_form.title,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.curriculumList = res.runTrainingList
        this.total = res.total
        // res.tchTrainingList.map(index => {
        //   if (index.training_type === 1) {
        //     return (index.training_type = "基础");
        //   }
        //   if (index.training_type === 2) {
        //     return (index.training_type = "产品");
        //   }
        //   if (index.training_type === 3) {
        //     return (index.training_type = "编程");
        //   }
        //   if (index.training_type === 4) {
        //     return (index.training_type = "平台");
        //   }
        // });
      })
    },
    //
    handleCurrent(val) {
      this.page_no = val
      this.trainingList()
    },

    handleClickCard(item) {
      this.firstTime === true
      console.log(item)

      if (!this.$store.state.user.schoolInfo.isTry) {
        this.$router.push({
          name: 'courses-training-details',
          query: {
            id: item.id,
            title: item.title,
          },
        })
        document.body.scrollTop = document.documentElement.scrollTop = 0
      } else {
        this.$message.warning('体验账号,暂无权限查看!')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  margin-bottom: 0px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.content {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.title {
  width: 100%;
  height: 63px;
  background-color: #fff;
  line-height: 63px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
}

.title_left {
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-left: 10px;
}

.main {
  width: 100%;
  height: auto;
  min-height: calc(100vh - 65px);
  background-color: #fff;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 5px;
}

.main .el-input {
  width: 337px;
  height: 30px;
}

.form {
  overflow: hidden;
}

.input_left {
  float: left;
}

.icon_right {
  float: right;
  cursor: pointer;
}

.new {
  position: relative;
  top: 0;
  right: 125px;
}

.top1 {
  position: absolute;
  top: 0px;
  left: 0;
}

.bottom1 {
  position: absolute;
  top: 8px;
  left: 0;
}

.new_txt {
  width: 50px;
  position: absolute;
  left: -25px;
  top: 3px;
}

.hot {
  position: relative;
  top: 0;
  right: 50px;
}

.top2 {
  position: absolute;
  top: 0px;
  left: 0;
}

.bottom2 {
  position: absolute;
  top: 8px;
  left: 0;
}

.hot_txt {
  width: 50px;
  position: absolute;
  left: -25px;
  top: 3px;
}

.video_list {
  border: 1px solid #e4e7ed;
  margin-bottom: 20px;
  border-radius: 5px;
  background: white;
  cursor: pointer;
}

.courses_img {
  height: 0;
  padding-bottom: 69%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 5px 5px 0px 0px;
  background-color: #ccc;
}

.courses_title {
  flex: 1;
  padding: 10px;
  & > div {
    display: flex;
    align-items: center;
    .left_bottom {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .top_tag,
    .right_bottom {
      flex-shrink: 0;
    }
  }
}

.top_tag {
  float: left;
  margin-left: 10px;
  color: rgb(241, 90, 36);
  font-size: 10px;
  border: 1px solid rgb(241, 90, 36);
  padding: 2px 4px;
  border-radius: 5px;
  // position: absolute;
  // width: 40px;
  // height: 26px;
  // color: rgba(255, 255, 255, 1);
  // background-color: rgba(24, 144, 255, 1);
  // border-radius: 4px;
  // font-size: 14px;
  // line-height: 26px;
  // text-align: center;
}

.title_subject {
  text-align: center;
  line-height: 26px;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  font-weight: bold;
  float: left;
  // width: 100%;
  // text-align: center;
  // line-height: 26px;
  // color: rgba(80, 80, 80, 1);
  // font-size: 16px;
  // font-weight: bold;
}

.title_bottom {
  color: rgba(80, 80, 80, 1);
  font-size: 14px;
  overflow: hidden;
  margin-top: 10px;
}

.left_bottom {
  float: left;
}

.right_bottom {
  float: right;
}

/deep/ .el-breadcrumb {
  line-height: 63px;
  padding-left: 20px;
}

.title_name {
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  display: -webkit-box;
  -webkit-line-clamp: 1; // 超出多少行
  -webkit-box-orient: vertical;
  text-align: left;
}
</style>
